import { getEnv } from "../environment";

type Am4Core = typeof import("@amcharts/amcharts4/core");
type Am4Charts = typeof import("@amcharts/amcharts4/charts");

export interface AmchartsModules {
    am4core: Am4Core;
    am4charts: Am4Charts;
}

let amchartsPromise: Promise<AmchartsModules> | null = null;

export function preloadAmcharts(): Promise<AmchartsModules> {
    amchartsPromise ??= Promise.all([
        import("@amcharts/amcharts4/core"),
        import("@amcharts/amcharts4/charts"),
        import("@amcharts/amcharts4/themes/animated"),
    ])
        .then(([am4core, am4charts, am4themes_animated]) => {
            am4core.useTheme(am4themes_animated.default);
            const license = getEnv("VITE_AMCHARTS_LICENSE");
            if (license) {
                am4core.addLicense(license);
            }
            return { am4core, am4charts };
        })
        .catch((error) => {
            amchartsPromise = null;
            throw error;
        });
    return amchartsPromise;
}

export function getAmcharts(): Promise<AmchartsModules> {
    return preloadAmcharts();
}
